import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { OptionModel } from 'Pages/survey'

export const optionApi = {
	getOne: async (id: number) => {
		const res = await axiosDS().get<OptionModel>(`${urls.survey.option}/${id}`)
		return res.data
	},
	createOne: async (question_id: number, data: OptionModel) => {
		const formData = new FormData()
		if (data.attachments_attributes && data.attachments_attributes[0]) {
			formData.append('data[attachments_attributes][][file]', data.attachments_attributes[0].file)
		}
		formData.append('data[text]', data.text)
		if (data.display_order) formData.append('data[display_order]', data.display_order.toString())
		const res = await axiosDS().post<OptionModel>(
			`${urls.survey.question}/${question_id}/option`,
			formData,
			{
				headers: {
					'content-type': 'multipart/form-data',
				},
			}
		)
		return res.data
	},
	updateOne: async (data: OptionModel) => {
		const formData = new FormData()
		if (data.attachments_attributes && data.attachments_attributes[0]) {
			formData.append('data[attachments_attributes][][file]', data.attachments_attributes[0].file)
		}
		if (data.next_question_id) {
			formData.append('data[next_question_id]', data.next_question_id.toString())
		}
		formData.append('data[display_order]', data.display_order.toString())
		formData.append('data[text]', data.text)
		const res = await axiosDS().patch<OptionModel>(`${urls.survey.option}/${data.id}`, formData, {
			headers: {
				'content-type': 'multipart/form-data',
			},
		})
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete(`${urls.survey.option}/${id}`)
		return res.data
	},
}
